import { render, staticRenderFns } from "./leftAside.vue?vue&type=template&id=2d71d358&scoped=true"
import script from "./leftAside.vue?vue&type=script&lang=js"
export * from "./leftAside.vue?vue&type=script&lang=js"
import style0 from "./leftAside.vue?vue&type=style&index=0&id=2d71d358&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d71d358",
  null
  
)

export default component.exports